export default __webpack_public_path__ + "static/media/ren_0032.7319810e.png";